import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=13d43958&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"
import style0 from "./Family.vue?vue&type=style&index=0&id=13d43958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d43958",
  null
  
)

export default component.exports